package fr.frux.feature.map

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel
import fr.frux.feature.map.site.MapArea

/**
 * Contrat de fabrique du [MapViewModel], honoré par le composition root.
 *
 * La feature déclare ce dont elle a besoin sans connaître le graphe : c'est le root (`composeApp`)
 * qui sait assembler le ViewModel depuis Metro, lui seul voyant les deux côtés (#43).
 */
fun interface MapViewModelFactory {
    /** [areaRequested] reçoit chaque aire interrogée pour les arbres : la couche lieux s'y aligne. */
    fun create(areaRequested: (MapArea) -> Unit): MapViewModel
}

/**
 * Fabrique installée par le composition root. Sans défaut, délibérément : un défaut fabriquerait
 * un ViewModel muet hors du graphe et la panne de câblage ne se verrait qu'à l'usage.
 */
val LocalMapViewModelFactory =
    staticCompositionLocalOf<MapViewModelFactory> {
        error("MapViewModelFactory absente : le composition root doit l'installer (cf. FruxCompositionRoot, #43)")
    }

/**
 * Fabrique le MapViewModel depuis la fabrique fournie par le root.
 *
 * Pas d'`expect/actual` : `viewModel {}` est multiplateforme, les quatre implémentations par cible
 * étaient identiques (cf. #107).
 */
@Composable
fun rememberMapViewModel(areaRequested: (MapArea) -> Unit = {}): MapViewModel {
    val factory = LocalMapViewModelFactory.current
    return viewModel { factory.create(areaRequested) }
}
